export enum SettingsTableTypeEnum {
  Projects = "projects",
  Users = "users",
  Invitations = "invitations",
}
